import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appSpecialCharactersValidations]',
  standalone: false
})
export class SpecialCharactersValidationsDirective {
  private nativeEl: HTMLInputElement;
  regexDashAllowed = /[^0-9a-zA-Z-\s]/g;
  regexNoSpecialCharacters = /[^0-9a-zA-Z\s]/g;

  @Input() dashAllowed: boolean;

  constructor(private el: ElementRef) {
    this.nativeEl = this.el.nativeElement;
  }


  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this.el.nativeElement.value;

    if(this.dashAllowed) {
      this.nativeEl.value = initalValue.replace(this.regexDashAllowed, '');
    } else {
      this.nativeEl.value = initalValue.replace(this.regexNoSpecialCharacters, '');
    }

    if (initalValue !== this.nativeEl.value) {
      event.stopPropagation();
    }
  }
}
